import styled, { css } from 'styled-components';
import { ifProp, theme } from 'styled-tools';

import { minWidth, units } from '@calm-web/design-system';

export const APP_WRAPPER_BOTTOM_MARGIN = 104;

export const Wrapper = styled.div<{
	$isZenMode: boolean;
	$isLargePlayer?: boolean;
	$isBannerVisible?: boolean;
	$hasBottomOverlay: boolean;
}>`
	position: relative;
	margin-bottom: ${p =>
		!p.$isLargePlayer && p.$hasBottomOverlay ? `${APP_WRAPPER_BOTTOM_MARGIN}px` : '0px'};
	opacity: ${p => (p.$isZenMode ? '0' : '1')};
	pointer-events: ${p => (p.$isZenMode ? 'none' : 'auto')};
	transition: opacity ${theme('animation.transition')};
	padding-top: ${ifProp('isBannerVisible', theme('app.mobileBannerHeight'), '0')};

	${minWidth('tablet')} {
		padding-top: ${ifProp('isBannerVisible', theme('app.bannerHeight'), '0')};
	}

	${p =>
		p.$isLargePlayer
			? css`
					min-height: 100vh;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
				`
			: ''};

	${minWidth('tablet')} {
		padding-bottom: ${p => (!p.$isLargePlayer && p.$hasBottomOverlay ? '100px' : '0')};
	}
`;

export const Main = styled.main`
	overflow: hidden;

	${minWidth('desktop')} {
		padding-left: ${theme('app.sidebarWidth')};
	}
`;

export const Container = styled.div<{
	$isVisible: boolean;
	$hasBanner?: boolean;
	$bottomOffset?: number;
	$isLargePlayer?: boolean;
	$hasBottomOverlay: boolean;
}>`
	height: 100%;
	opacity: ${p => (p.$isVisible ? '1' : '0.1')};
	padding: ${p => (p.$hasBanner ? 'calc(min(64px,20vh)) 0 16px' : 'calc(min(64px,20vh)) 16px 16px')};
	padding-top: 0;
	transition: opacity ${theme('animation.transition')};
	visibility: ${p => (p.$isVisible ? 'visible' : 'hidden')};
	margin-bottom: ${p =>
		p.$isLargePlayer
			? units(2)
			: `${
					p.$bottomOffset
						? Math.max(p.$bottomOffset - (p.$hasBottomOverlay ? APP_WRAPPER_BOTTOM_MARGIN : 0), 0)
						: 0
				}px`};
	${minWidth('tablet')} {
		margin-bottom: ${p =>
			p.$isLargePlayer
				? units(2)
				: `${
						p.$bottomOffset
							? Math.max(p.$bottomOffset - (p.$hasBottomOverlay ? APP_WRAPPER_BOTTOM_MARGIN : 0), 0)
							: 0
					}px`};
	}

	${minWidth('tablet')} {
		padding: ${p => (p.$hasBanner ? '80px 16px 16px' : '64px 16px 32px')};
	}
`;

export const LoaderWrapper = styled.div<{}>`
	bottom: 0;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;

	${minWidth('desktop')} {
		left: ${theme('app.sidebarWidth')};
	}
`;
